import React, { useEffect, useState } from "react";
import "../../css/styles.css";
import axios from "axios";
import ArticleNotFound from "../ArticleNotFound";
import ArticleDetails from "../ArticleDetails";
import Banner from "../Banner";

import {
  generateNewPageData,
  track,
  generateNewPageError,
} from "../../util/tracking";

const SubmissionTrackingService = ({ uuid }: {uuid: string}) => {
  const [submissionDetails, setSubmissionDetails] = useState<SubmissionDetails|Record<string, never>>({});
  const [error, isError] = useState(false);

  useEffect(() => {
    if (Object.keys(submissionDetails).length > 0) {
      track("newPage", generateNewPageData("landingpage", submissionDetails as SubmissionDetails));
    }
  }, [submissionDetails]);

  useEffect(() => {
    if (error)
      track(
        "newPage",
        generateNewPageError(
          "notFoundPage",
          "ae-could not find results for submission."
        )
      );
  }, [error]);

  useEffect(() => {
    axios
      .get(`${process.env.STS_API_ENDPOINT}${uuid}`)
      .then(({ data }) => setSubmissionDetails(data))
      .catch(() => isError(true));
  }, [uuid]);

  return (
    <>
      <Banner />
      <div className="divider" />
      <div className="track-title container">
        Peer review status
      </div>
      { error ? <ArticleNotFound /> : Object.keys(submissionDetails).length > 0 ? <ArticleDetails {...submissionDetails} /> : null }
    </>
  );
};

export default SubmissionTrackingService;
